import { render, staticRenderFns } from "./wechat-analysis.vue?vue&type=template&id=bbf6e606&scoped=true&"
import script from "./wechat-analysis.vue?vue&type=script&lang=js&"
export * from "./wechat-analysis.vue?vue&type=script&lang=js&"
import style0 from "./wechat-analysis.vue?vue&type=style&index=0&id=bbf6e606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf6e606",
  null
  
)

export default component.exports